import ky from "ky";
import getToken from "../hooks/getToken";
import uiStore from "../store/UiStore";
import { DateTime } from "luxon";

let isRedirecting = false;

const handleSessionTimeout = () => {
  // Prevent multiple redirects (check both memory flag and sessionStorage)
  if (isRedirecting || sessionStorage.getItem("isRedirectingToLogin")) return;
  isRedirecting = true;
  sessionStorage.setItem("isRedirectingToLogin", "true");

  // Clear MSAL storage
  Object.keys(window.localStorage).forEach((key) => {
    if (key.startsWith("msal")) {
      window.localStorage.removeItem(key);
    }
  });
  Object.keys(window.sessionStorage).forEach((key) => {
    if (key.startsWith("msal")) {
      window.sessionStorage.removeItem(key);
    }
  });
  // Redirect to login page
  window.location.href = "/";
};

const dispatcher = ky.extend({
  timeout: 60000,
  credentials: "include",
  hooks: {
    beforeRequest: [
      async (request: Request) => {
        const token = await getToken();
        if (token) {
          request.headers.set("Authorization", "Bearer " + token.accessToken);
        } else {
          return new Response("No token", { status: 401 });
        }
      },
    ],
    afterResponse: [
      (request, options, response) => {
        // Handle session timeout (401 Unauthorized, 403 Forbidden, 440 Login Timeout)
        if (response.status === 401 || response.status === 403 || response.status === 440) {
          console.warn("Session timeout detected, redirecting to login...");
          handleSessionTimeout();
          return;
        }

        if (response.status === 200 || response.status === 201) {
          if (
            !["userRole", "availableSystems"].some((v) =>
              request.url.includes(v)
            )
          ) {
            uiStore.setLastUpdate(DateTime.now());
          }
        }
      },
    ],
  },
});

export default dispatcher;
